import * as MediaQuery from 'react-responsive';
import * as React from 'react';

interface Props {

}

interface State {

}

class DeviceTest extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        return (
            <div>
                <div>Device Test!</div>
                <MediaQuery query='(min-device-width: 1224px)'>
                    <div>You are a desktop or laptop</div>
                    <MediaQuery query='(min-device-width: 1824px)'>
                        <div>You also have a huge screen</div>
                    </MediaQuery>
                    <MediaQuery query='(max-width: 1224px)'>
                        <div>You are sized like a tablet or mobile phone though</div>
                    </MediaQuery>
                </MediaQuery>
                <MediaQuery query='(max-device-width: 1224px)'>
                    <div>You are a tablet or mobile phone</div>
                </MediaQuery>
                <MediaQuery query='(orientation: portrait)'>
                    <div>You are portrait</div>
                </MediaQuery>
                <MediaQuery query='(orientation: landscape)'>
                    <div>You are landscape</div>
                </MediaQuery>
                <MediaQuery query='(min-resolution: 2dppx)'>
                    <div>You are retina</div>
                </MediaQuery>
            </div>
        );
    }
}

export default DeviceTest;


// WEBPACK FOOTER //
// ./src/components/DeviceTest.tsx